<template>
  <v-container class="event p-0" v-if="category" fluid>
    <vue-headful :title="category.name + $t('title')"></vue-headful>
    <!--<HkiaraceBannerFrame :src="'api/static/'+category.banner"-->
    <HkiaraceBannerFrame :src="require('../../../assets/acc.jpg')"
                         :label="category.name.toUpperCase()">
      <div v-if="events.length === 0" class="py-6">
        {{ $t('home.coming_soon') }}
        <!--        {{ $t('event.no_event_msg') }}-->
        <!--        <router-link :to="{name: 'past-event'}">{{ $t('event.no_event_msg_link') }}</router-link>-->
      </div>
      <div class="event-details" v-if="categoryId !== '52b7be40-2c4c-4731-ac0a-3a7df58d5165'">
        <HkiaraceCardDisplayFrame
            v-for="(event, index) in events"
            v-bind:key="index"
            :is-reverse="index % 2 !== 0"
            :is-default-order-sm="true"
            :image-src="host + 'static/' + event.banner"
            :is-blur-background="true"
        >
          <template slot="sub-title">
            {{ event.category.name }}
          </template>
          <template slot="title">
            <span v-html="event.name"></span>
          </template>
          <template slot="content">
            <div class="event-detail-content">
              <div class="content-row">
                <div class="content-field">
                  <div class="field-label">
                    {{ $t('event.date') }}
                  </div>
                  <div class="field-content" v-html="eventDateLabel(event)">
                  </div>
                </div>
                <div class="content-field" v-if="event.signup_mode === -1 || event.signup_mode === 1">
                  <div class="field-label">
                    {{ $t('event.time') }}
                  </div>
                  <div class="field-content">
                    {{ eventTimeLabel(event) }}
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="content-field">
                  <div class="field-label">
                    {{ $t('event.location') }}
                  </div>
                  <div class="field-content">
                    {{ event.location }}
                  </div>
                </div>
                <div class="content-field" v-if="event.quota !== -1">
                  <div class="field-label">
                    {{ $t('event.quota') }}
                  </div>
                  <div class="field-content">
                    {{ $t('event.quota_template', {quota: event.quota}) }}
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="content-field">
                  <div class="field-label">
                    {{ $t('event.fee') }}
                  </div>
                  <div class="field-content" v-html="eventFeeLabel(event)">
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="content-field">
                  <div class="field-label">
                    {{ $t('event.languages') }}
                  </div>
                  <div class="field-content">
                    {{ eventLanguageLabel(event) }}
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="content-field">
                  <div class="field-label">
                    {{ $t('event.remarks') }}
                  </div>
                  <div class="field-content" v-html="event.remarks">
                  </div>
                </div>
              </div>
              <v-row>
                <v-col class="event-detail-buttons">
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.poster"
                         @click="downloadFile(event.poster)">
                    <v-icon>mdi-download</v-icon>
                    {{ $t('event.download_poster') }}
                  </v-btn>
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.attachment_id"
                         @click="downloadFile(event.attachment_id)">
                    <v-icon>mdi-download</v-icon>
                    {{ $t('event.download_attachment') }}
                  </v-btn>
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.memorable_moment_enabled"
                         :to="{name: 'past-event-detail', params: {eventId: event.id}}">
                    {{ $t('event.show_past_moment') }}
                  </v-btn>
                  <v-btn color="primary" dark rounded
                         class="function-button"
                         v-if="canEnrollEvent(event)"
                         @click="onEventEnrollClick(event)">
                    <v-icon>mdi-calendar-check</v-icon>
                    {{ $t('event.enroll') }}
                  </v-btn>
                  <v-btn color="primary" rounded disabled
                         class="function-button"
                         v-if="enrollments.indexOf(event.id) !== -1 && event.signup_mode !== -1">
                    <v-icon>mdi-calendar-check</v-icon>
                    {{ $t('event_status.enrolled') }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
        </HkiaraceCardDisplayFrame>
      </div>
      <div class="event-details" v-if="categoryId === '52b7be40-2c4c-4731-ac0a-3a7df58d5165'">
        <HkiaraceCardDisplayFrameForceMobile
            v-for="(event, index) in events"
            v-bind:key="index"
            :is-reverse="index % 2 !== 0"
            :is-default-order-sm="true"
            :image-src="host + 'static/' + event.banner"
            :is-blur-background="true"
        >
          <template slot="title">
            <span v-html="event.name"></span>
          </template>
          <template slot="sub-title">
            <span v-html="event.location"></span>
          </template>
          <template slot="content">
            <div class="event-detail-content">
              <div class="content-row">
                <div class="content-field">
                  <div class="field-content" v-html="event.remarks">
                  </div>
                </div>
              </div>
              <v-row>
                <v-col class="event-detail-buttons">
                  <a href="tnc_en.pdf" target="_blank">
                    <v-btn color="primary" rounded
                           class="function-button">
                      <v-icon>mdi-download</v-icon>
                      {{ $t('event.download_result') }}
                    </v-btn>
                  </a>
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.poster"
                         @click="downloadFile(event.poster)">
                    <v-icon>mdi-download</v-icon>
                    {{ $t('event.download_poster') }}
                  </v-btn>
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.attachment_id"
                         @click="downloadFile(event.attachment_id)">
                    <v-icon>mdi-download</v-icon>
                    {{ $t('event.download_attachment') }}
                  </v-btn>
                  <v-btn color="grey" dark rounded
                         class="function-button"
                         v-if="event.memorable_moment_enabled"
                         :to="{name: 'past-event-detail', params: {eventId: event.id}}">
                    {{ $t('event.show_past_moment') }}
                  </v-btn>
                  <v-btn color="primary" dark rounded
                         class="function-button"
                         v-if="canEnrollEvent(event)"
                         @click="onEventEnrollClick(event)">
                    <v-icon>mdi-calendar-check</v-icon>
                    {{ $t('event.enroll') }}
                  </v-btn>
                  <v-btn color="primary" rounded disabled
                         class="function-button"
                         v-if="enrollments.indexOf(event.id) !== -1 && event.signup_mode !== -1">
                    <v-icon>mdi-calendar-check</v-icon>
                    {{ $t('event_status.enrolled') }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
        </HkiaraceCardDisplayFrameForceMobile>
      </div>
    </HkiaraceBannerFrame>

    <v-dialog v-model="enrollEventDialogShown"
              width="80vw"
              max-width="600px">
      <v-card light
              class="event-enroll-dialog"
              v-if="enrollingEvent"
              width="80vw"
              max-width="600px">
        <v-card-title></v-card-title>
        <v-card-text>
          <v-container fluid>
            <!-- Select Session -->
            <v-form ref="enrollForm">
              <v-row v-if="enrollingEvent.signup_mode === 2">
                <v-col cols="12" class="text-color-primary font-size-70 font-weight-bold text-left">
                  {{ $t('event.select_session') }}
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="enrollingSessionId"
                                 :rules="[value => !!value || $t('register.required_fields')]">
                    <v-radio v-for="session in enrollingEvent.sessions"
                             :label="session.name"
                             :value="session.id">
                      <template #label>
                        <div>
                          <div><b>{{ session.name }}</b></div>
                          <div>{{ $parseDate(session.start, 'd/M/y, T') }} - {{ $parseDate(session.end, 'T') }}</div>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- Select Series -->
              <v-row v-if="enrollingEvent.signup_mode === 3">
                <v-col class="text-color-primary font-size-70 font-weight-bold text-left"
                       cols="12">
                  {{ $t('event.select_series') }}
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="enrollingSeriesId"
                                 :rules="[value => !!value || $t('register.required_fields')]">
                    <v-radio v-for="series in enrollingEvent.series"
                             :label="series.name"
                             :value="series.id">
                      <template #label>
                        <div>
                          <div><b>{{ series.name }}</b></div>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- Multi-tier Fee -->
              <v-row v-if="isEventMultiFeeTiers(enrollingEvent)">
                <v-col class="text-color-primary font-size-70 font-weight-bold text-left"
                       cols="12">
                  {{ $t('event.meta') }}
                </v-col>
                <v-col>
                  <v-text-field v-for="tier in eventFeeTiers(enrollingEvent)"
                                :key="tier.id"
                                :label="$localeGet(tier, 'name') + ': HKD ' + tier.fee"
                                type="number"
                                min="0"
                                :max="tier.max || 10"
                                v-model="enrollingMeta[tier.id]"
                                :rules="[value => isFeeEntered(value) || $t('register.required_fields')]"
                                prepend-inner-icon="mdi-minus"
                                @click:prepend-inner="decreaseFee(tier)"
                                append-icon="mdi-plus"
                                @click:append="increaseFee(tier)"
                                @blur="$set(enrollingMeta, tier.id, Math.min(tier.max, enrollingMeta[tier.id] || 0))"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text
                 @click="enrollEventDialogShown = false">
            {{ $t('cancel') }}
          </v-btn>

          <v-btn text color="primary"
                 @click="enrollEvent()">
            {{ $t('event.enroll') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="enrollEventSuccessDialogShown"
              width="80vw"
              max-width="400px">
      <v-card light
              class="event-enroll-success-dialog"
              width="80vw"
              max-width="600px">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="enrollment-success-title text-color-primary font-size-70 font-weight-bold">
                {{ $t('enrollment_success.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('enrollment_success.description') }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text
                 @click="enrollEventSuccessDialogShown = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import HkiaraceCardDisplayFrame from "../../../components/HkiaraceCardDisplayFrame";
import HkiaraceCardDisplayFrameForceMobile from "../../../components/HkiaraceCardDisplayFrameForceMobile";
import {DateTime} from 'luxon';
import {HOST} from '../../../main'

export default {
  name: 'Event',
  components: {HkiaraceBannerFrame, HkiaraceCardDisplayFrame, HkiaraceCardDisplayFrameForceMobile},
  data() {
    return {
      categoryId: this.$route.params.categoryId,
      category: null,
      events: [],
      enrollments: [],

      enrollingEvent: null,
      enrollingSessionId: null,
      enrollingSeriesId: null,
      enrollingMeta: {},
      enrollEventDialogShown: false,
      enrollEventSuccessDialogShown: false,
      host: HOST
    };
  },
  mounted() {
    this.getCategory();
    this.getEvents();
  },
  methods: {
    getCategory() {
      this.$callAPI('hkiarace/event_category/', {category_id: this.categoryId}, function (response) {
        this.category = response.body.category;
      });
    },
    getEvents() {
      let v = this;
      this.$callAPI('hkiarace/event/', {category_id: this.categoryId}, function (response) {
        this.events = response.body.events;

        this.enrollments = response.body.enrollments.map((e) => e.event.id);

        if (this.jumpToEventId) {
          let index = 0;
          this.events.forEach(function (e, i) {
            if (e.id === v.jumpToEventId) {
              index = i;
            }
          });

          this.showingEventIndex = index;
        }
      });
    },
    eventDateLabel(event) {
      let v = this;
      if (event.signup_mode === -1 || event.signup_mode === 1) {
        return DateTime.fromISO(event.date).toFormat('yyyy-MM-dd');
      } else if (event.signup_mode === 2) {
        // let sortedSessions = [...event.sessions]
        // sortedSessions.sort((a, b) => {
        //   if (a.start === b.start) {
        //     return 0;
        //   } else {
        //     return a.start < b.start ? -1 : 1;
        //   }
        // });

        return event.sessions.map((session) => {
          let start = DateTime.fromISO(session.start);
          let end = DateTime.fromISO(session.end);


          let datetime_label = session.name + ": " + start.toFormat('d/M/y, T') + " - " + end.toFormat('T');
          let quota_label = session.quota === -1 ? "" : " (" + v.$t('event.quota_template', {quota: session.quota}) + ")";

          return datetime_label + quota_label;
        }).join('<br>');
      } else if (event.signup_mode === 3) {
        return event.series.map((series) => {
          return series.name + (series.quota === -1 ? "" : " (" + v.$t('event.quota_template', {quota: series.quota}) + ")");
        }).join("<br>");
      }

      return "";
    },
    eventDateLabelRow(event) {
      if (event.signup_mode === -1 || event.signup_mode === 1) {
        return 1;
      } else if (event.signup_mode === 2) {
        return event.sessions.length;
      } else if (event.signup_mode === 3) {
        return event.series.length;
      }
    },
    eventTimeLabel(event) {
      if (event.signup_mode === -1 || event.signup_mode === 1) {
        return DateTime.fromISO(event.from_time).toFormat('HH:mm') + ' - ' + DateTime.fromISO(event.to_time).toFormat('HH:mm');
      }
      return '';
    },
    eventFeeTiers(event) {
      return JSON.parse(event.fee_tiers || '[]');
    },
    eventFeeLabel(event) {
      let feeTiers = this.eventFeeTiers(event);

      if (feeTiers.length === 0) {
        return this.$t('event.free');
      } else if (feeTiers.length === 1 && !feeTiers[0].name_en) {
        return 'HKD ' + feeTiers[0].fee;
      } else {
        return feeTiers.map((t) => {
          return (this.$localeGet(t, 'name') ? this.$localeGet(t, 'name') + ": " : "") + ("HKD " + t.fee);
        }).join('<br>');
      }
    },
    eventFeeLabelRow(event) {
      if (!this.isEventMultiFeeTiers(event)) {
        return 1;
      } else {
        let feeTiers = this.eventFeeTiers(event);

        return feeTiers.length;
      }
    },
    isEventMultiFeeTiers(event) {
      let feeTiers = this.eventFeeTiers(event);

      return feeTiers.length !== 0 && feeTiers[0].name_en;
    },
    eventLanguageLabel(event) {
      let v = this;
      return JSON.parse(event.languages).map(function (l) {
        return v.$t('languages.' + l);
      }).join(", ")
    },
    eventNeedFurtherInput(event) {
      // Need to select session or series
      if (event.signup_mode === 2 || event.signup_mode === 3) {
        return true;
      }

      // Multi-tier Fee
      let feeTiers = JSON.parse(event.fee_tiers || '[]');
      if (feeTiers.length > 0 && !!feeTiers[0].name_en) {
        return true;
      }

      return false;
    },
    downloadFile(file_id) {
      window.open('/api/static/' + file_id, '_blank');
    },
    onEventEnrollClick(event) {
      if (this.$store.state.user.id) {
        this.enrollingEvent = event;
        this.enrollingSessionId = null;
        this.enrollingSeriesId = null;
        this.enrollingMeta = {};
        if (this.eventNeedFurtherInput(event)) {
          this.enrollEventDialogShown = true;
        } else {
          this.enrollEvent();
        }
      } else {
        this.$showAlertMessage(this.$t('login_msg'), () => {
          this.$router.push({name: 'login', query: {after: this.$route.path + encodeURI('?e=' + event.id)}})
        })
      }
    },
    isFeeEntered(v) {
      if (this.isEventMultiFeeTiers(this.enrollingEvent)) {
        let entered = false;
        let v = this;

        Object.keys(this.enrollingMeta).forEach((k) => {
          if (parseInt(v.enrollingMeta[k]) > 0) {
            entered = true;
          }
        });

        return entered;
      } else {
        return true;
      }
    },
    increaseFee(tier) {
      this.$set(this.enrollingMeta, tier.id, Math.min(tier.max, (this.enrollingMeta[tier.id] || 0) + 1));
    },
    decreaseFee(tier) {
      this.$set(this.enrollingMeta, tier.id, Math.max(0, (this.enrollingMeta[tier.id] || 0) - 1));
    },
    canEnrollEvent(event) {
      return this.enrollments.indexOf(event.id) === -1 && event.signup_mode !== -1 && (DateTime.fromISO(event.signup_until).toJSDate() > new Date())
    },
    enrollEvent() {
      if (this.$store.state.user.id) {
        if ((!this.eventNeedFurtherInput(this.enrollingEvent) || this.$refs.enrollForm.validate()) && confirm(this.$t('event.enroll_confirm_msg'))) {
          this.$callAPI('hkiarace/event/enroll/', {
            event_id: this.enrollingEvent.id,
            session_id: this.enrollingSessionId,
            series_id: this.enrollingSeriesId,
            meta: JSON.stringify(this.enrollingMeta),
          }, function (response) {
            this.enrollEventDialogShown = false;
            this.enrollEventSuccessDialogShown = true;
            this.getEvents();
          }, function (response) {
            if (response.status === 401) {
              this.$router.push({name: 'login', query: {after: this.$route.path}});
            } else if (response.body.msg === 'error_messages.validate_email') {
              this.$showAlertMessage(this.$t('error_messages.validate_email'));
            } else if (response.body.msg === 'error_messages.invalid_id') {
              this.$showAlertMessage(this.$t('error_messages.id_not_validated'), () => {
                this.$router.push({name: 'id-verify'});
              });
            } else {
              this.$showAlertMessage();
            }
          })
        }
      } else {
        let v = this;
        this.$showAlertMessage(this.$t('login_msg'), function () {
          v.$router.push({name: 'login', query: {after: v.$route.path + encodeURI('?e=' + event.id)}})
        });
      }
    },
  },
  watch: {
    '$route.params.categoryId'(newVal) {
      this.categoryId = newVal;
      this.getCategory();
      this.getEvents();
    },
  },
}
</script>

<style lang="less">
@import "../../../styles/client/main";

.event {
  .event-details {
    .card-display-container, .card-display-container-force-mobile {
      background-color: white;

      @media only screen and (max-width: 1200px) {
        margin-bottom: 1rem;
      }
    }

    .event-detail-content {
      .content-row {
        display: flex;
        flex-wrap: wrap;

        .title-font();

        .content-field {
          width: 50%;
          flex-grow: 1;

          padding: 10px 0;

          .field-label {
            color: #8E765B;
          }

          .field-content {

          }


          @media only screen and (max-width: 1200px) {
            width: 100%;
          }
        }
      }

      .v-label {
        color: #8E765B;
        .title-font()
      }

      .v-text-field > .v-input__control > .v-input__slot:before {
        display: none;
      }

      .v-text-field > .v-input__control > .v-input__slot:after {
        display: none;
      }
    }

    .event-detail-buttons {
      .v-btn {
        margin-right: 1rem;
        margin-top: .5rem;
      }
    }
  }

  .event-enroll-dialog {

  }
}
</style>
